import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-temperature-detail-template',
  templateUrl: './temperature-detail-template.component.html',
  styleUrls: ['./temperature-detail-template.component.less']
})
export class TemperatureDetailTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
